import React, { useEffect, useState } from 'react';
import Logo from './Logo';

/**
 * Brand intro animation — only plays once per browser session.
 * Logo writes itself in over ~1.2s, then fades out as the home page becomes interactive.
 */
const IntroAnimation = () => {
  const [show, setShow] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    let mounted = true;
    try {
      if (sessionStorage.getItem('fad_intro_seen')) {
        return;
      }
    } catch (e) {
      // sessionStorage unavailable — skip the animation
      return;
    }

    setShow(true);

    const fadeTimer = setTimeout(() => {
      if (!mounted) return;
      setFading(true);
    }, 1500);

    const hideTimer = setTimeout(() => {
      if (!mounted) return;
      try { sessionStorage.setItem('fad_intro_seen', '1'); } catch (e) { /* noop */ }
      setShow(false);
    }, 2200);

    return () => {
      mounted = false;
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-black flex items-center justify-center transition-opacity duration-700 ${
        fading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      aria-hidden="true"
    >
      <div className="intro-fade-in flex flex-col items-center">
        <Logo />
        <div className="intro-tagline mt-5 font-display tracking-[0.4em] text-[10px] text-white/60">
          DRIVEN BY YOU &middot; BUILT BY US
        </div>
      </div>
      <style>{`
        @keyframes introLogo {
          0%   { opacity: 0; transform: translateY(8px); filter: blur(8px); }
          60%  { opacity: 1; transform: translateY(0);   filter: blur(0); }
          100% { opacity: 1; transform: translateY(0);   filter: blur(0); }
        }
        @keyframes introTag {
          0%, 40% { opacity: 0; letter-spacing: 0.1em; }
          100%    { opacity: 1; letter-spacing: 0.4em; }
        }
        .intro-fade-in > div:first-child,
        .intro-fade-in > .flex {
          animation: introLogo 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .intro-tagline {
          animation: introTag 1.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </div>
  );
};

export default IntroAnimation;
